export default __webpack_public_path__ + "static/img9-2f5110b9384a1ec21db37c5f2ab472c5.jpg";